export const tipsColor = {
  NotAvailable: "#999999", // Chưa mở bán
  Available: "#ffe797", // Đang mở bán
  Pending: "#ffff07", // Đang mở bán
  InProgress: "#36761c", // Chờ xác nhận cọc
  Deposited: "#cc0103", // Đã cọc
  SignedAgreement: "#cc0103", // Đã ký thỏa thuận
  Cancelled: "#cc0103", // Đã hủy
  Complete: "#664ea5", // Đã ký hợp đồng
  Completed: "#664ea5", // Đã hoàn thành
  Liquidated: "#664ea5", // Đã thanh lý
  Recalled: "#999999",
};

export const order = [
  "NotAvailable", // Chưa mở bán
  "Available", // Đang mở bán
  "InProgress", // Chờ xác nhận cọc
  "Deposited", // Đã cọc
  "SignedAgreement", // Đã ký thỏa thuận
  "Complete", // Đã ký hợp đồng
  "Liquidated", // Đã thanh lý
];
